import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import { useFormik } from "formik";
import * as Yup from "yup";
import { request } from "../../config/request.ts";
import { toast } from "react-toastify";
import PageHeader from "../../shared/PageHeader/index.tsx";
import TextField from "../../shared/TextField/index.tsx";
import SelectField from "../../shared/SelectField/index.tsx";
import PageWrapper from "../../shared/PageWrapper/index.tsx";
import "../../styles/scss/Form.scss";

export default function NatureCreateEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      natureName: "",
      status: "Active",
    },
    validationSchema: Yup.object({
      natureName: Yup.string().required("Nature name is required"),
    }),
    onSubmit: async (values) => {
      try {
        let response;
        if (id) {
          response = await request.put("/api/updateNature/" + id, values);
        } else {
          response = await request.post("/api/createNature", values);
        }

        if (response?.data?.status) {
          toast.success("Nature saved successfully!");
          navigate("/admin/natures");
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            "An error occurred. Please try again.",
        );
      }
    },
  });

  useEffect(() => {
    if (id) {
      const fetchNature = async () => {
        setLoading(true);
        try {
          const response = await request.get(`/api/getNatureById/${id}`);
          const nature = response.data.data;
          formik.setValues({
            natureName: nature.natureName || "",
            status: nature.status === "Active" || nature.status === true ? "Active" : "Inactive",
          });
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      };

      fetchNature();
    }
  }, [id]);

  return (
    <PageWrapper loading={loading}>
      <Box className="form-container">
        <Box className="form-page">
          <Box className="form-header">
            <PageHeader
              title={
                id && id !== "new" ? "Edit Nature" : "Create New Nature"
              }
              secondaryButton={{
                label: "Cancel",
                onClick: () => navigate("/admin/natures"),
              }}
              primaryButton={{
                label: id && id !== "new" ? "Update Nature" : "Create Nature",
                icon: <span className="material-symbols-outlined">save</span>,
                onClick: () => formik.handleSubmit(),
              }}
            />
          </Box>

          <Box className="form-card">
            <Box className="form-card-body">
              <Box className="form-grid form-grid--2">
                <Box className="form-field">
                  <TextField
                    name="natureName"
                    label="Nature Name"
                    type="text"
                    formik={formik}
                    autoFocus
                  />
                </Box>
                <Box className="form-field">
                  <SelectField
                    name="status"
                    label="Status"
                    formik={formik}
                    options={[
                      { value: "Active", label: "Active" },
                      { value: "Inactive", label: "Inactive" },
                    ]}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </PageWrapper>
  );
}
